import React, { useState, useEffect, PureComponent } from "react";
import "./css/SCPChart.css";
import {
  Tooltip,
  Legend,
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from "recharts";

import { Styles, color } from "./SCPChartHelpers";

import { RadarCustomTooltip } from "./CustomToolTip";

const SCPRadarChart = ({ jsonData, title }) => {
  const [inputData, setInputData] = useState([]);

  const getRadarChart = () => {
    const keysArr = Object.keys(jsonData[0]).slice(1);
    const valuesArr = Object.values(jsonData[0]).slice(1);
    const radarArr = [];
    keysArr.forEach((item, index) => {
      if (typeof valuesArr[index] != "string") {
        radarArr.push(
          <td>
            <RadarChart
              cx={300}
              cy={250}
              outerRadius={150}
              width={500}
              height={500}
              data={jsonData}
            >
              <Tooltip
                content={<RadarCustomTooltip active={false} payload={[]} />}
              />
              <PolarGrid stroke="silver" className="PolarGrid" />
              <PolarAngleAxis
                className="AxisLabels"
                dataKey={Object.keys(jsonData[0])[0]}
              />
              <PolarRadiusAxis angle={30} domain={[0, 150]} />
              <Radar
                name={item}
                dataKey={item}
                stroke={color[index]}
                fill={color[index]}
                fillOpacity={0.6}
                dot={{
                  r: 4,
                  fillOpacity: 1,
                }}
              />
              <Legend />
            </RadarChart>
          </td>
        );
      }
    });
    return radarArr;
  };

  useEffect(() => {
    const jsonString = document.getElementById("inputData").textContent;
    if (jsonString) {
      const values = new Set();
      jsonData.forEach((item) => {
        values.add(item);
      });
      setInputData(Array.from(values));
      setInputData(jsonData);
    }
  }, []);

  return (
    <>
      <div className="chartTitle">{title}</div>
      <table>
        <tr>{getRadarChart()}</tr>
      </table>
    </>
  );
};

export default SCPRadarChart;
